import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class QuarterbackStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.PassComplete &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        // Penalty enforcement moves the ball but never counts as passing
        // yards, and the pass is measured to the spot where the receiver's own
        // advance ended -- where he fumbled, or where he lateraled the ball
        // away. What another player does from there is his own yardage
        // (fumble return, lateral), so counting it here would credit it twice.
        const yardsGained = play.getYardsGained(
            gameContext.getFieldDirectionMultiplier(),
            null,
            [
                FootballState.PenaltyAccepted,
                FootballState.PlayPenaltyPenaltyAccepted,
                // A lateral's spot is where the next player caught it, so it
                // belongs to him. A fumble's spot, when the operator enters
                // one, is where the receiver's own advance ended and counts.
                FootballState.Lateral
            ],
            [FootballState.Fumble, FootballState.Lateral]
        );
        const passFragment = play.getPreceedingFragment(fragment, [
            FootballState.Pass,
            FootballState.FieldGoalFakePass,
            FootballState.PatPass
        ]);

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: passFragment.passedBy.teamId,
            playerId: passFragment.passedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: passFragment.id,
            category: FootballStatsCategory.PASS,
            values: {
                yards: yardsGained,
                completed: 1
            }
        });
    }
}
